export default __webpack_public_path__ + "static/media/finSauna.e28722cb.png";